__turbopack_context__.v({
  "alertYellow": "_7NA6pG_alertYellow",
  "backgroundImage": "_7NA6pG_backgroundImage",
  "black": "_7NA6pG_black",
  "black90": "_7NA6pG_black90",
  "blog": "_7NA6pG_blog",
  "blogItem": "_7NA6pG_blogItem",
  "card": "_7NA6pG_card",
  "cardContainer": "_7NA6pG_cardContainer",
  "cardPanel": "_7NA6pG_cardPanel",
  "cardPanelSection": "_7NA6pG_cardPanelSection",
  "container": "_7NA6pG_container",
  "content": "_7NA6pG_content",
  "cyan": "_7NA6pG_cyan",
  "darkStone": "_7NA6pG_darkStone",
  "footerText": "_7NA6pG_footerText",
  "fuschiaPunch": "_7NA6pG_fuschiaPunch",
  "image": "_7NA6pG_image",
  "increasedPadding": "_7NA6pG_increasedPadding",
  "limeSorbet": "_7NA6pG_limeSorbet",
  "multiCardRow": "_7NA6pG_multiCardRow",
  "olive100": "_7NA6pG_olive100",
  "olive20": "_7NA6pG_olive20",
  "paddingBottom0": "_7NA6pG_paddingBottom0",
  "paddingBottom112": "_7NA6pG_paddingBottom112",
  "paddingBottom128": "_7NA6pG_paddingBottom128",
  "paddingBottom16": "_7NA6pG_paddingBottom16",
  "paddingBottom32": "_7NA6pG_paddingBottom32",
  "paddingBottom48": "_7NA6pG_paddingBottom48",
  "paddingBottom64": "_7NA6pG_paddingBottom64",
  "paddingBottom80": "_7NA6pG_paddingBottom80",
  "paddingBottom96": "_7NA6pG_paddingBottom96",
  "paddingTop0": "_7NA6pG_paddingTop0",
  "paddingTop112": "_7NA6pG_paddingTop112",
  "paddingTop128": "_7NA6pG_paddingTop128",
  "paddingTop16": "_7NA6pG_paddingTop16",
  "paddingTop32": "_7NA6pG_paddingTop32",
  "paddingTop48": "_7NA6pG_paddingTop48",
  "paddingTop64": "_7NA6pG_paddingTop64",
  "paddingTop80": "_7NA6pG_paddingTop80",
  "paddingTop96": "_7NA6pG_paddingTop96",
  "privacyItem": "_7NA6pG_privacyItem",
  "row": "_7NA6pG_row",
  "softBlack": "_7NA6pG_softBlack",
  "teal100": "_7NA6pG_teal100",
  "teal20": "_7NA6pG_teal20",
  "warmStone": "_7NA6pG_warmStone",
  "white": "_7NA6pG_white",
});
